import { createSlice } from '@reduxjs/toolkit';

const loaderSlice = createSlice({
  name: 'loader',
  initialState: {},
  reducers: {
    showLoader: (state, action) => {
      state[action.payload] = true;
    },

    hideLoader: (state, action) => {
      state[action.payload] = false;
    },

    clearAllLoaders: (state) => {
      // Clear all loader states
      Object.keys(state).forEach((key) => {
        state[key] = false;
      });
    },
  },
});

export const { showLoader, hideLoader, clearAllLoaders } = loaderSlice.actions;
export default loaderSlice.reducer;
